var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("header"),_c('div',{staticClass:"chart-wrapper"},[_c('bar-chart-component',{ref:"barChart",attrs:{"chart-data":_vm.processedChartData,"chart-options":_vm.mergedOptions}})],1),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }